module.exports = __webpack_public_path__ + "img/bull_time2.301275ba.gif";